import { Accordion, Divider, Grid, Space, Text } from '@mantine/core';
import { formatDate } from '../../../helpers/date-convert';
import { BusinessOnboardingInformation } from '../../../type/admin.types';
import { TextInfo } from '../../safe-text/safe-text.component';
import XInfoTabTitle from '../../x-components/x-info-tab-title.component';
import MerchantInfoSettlement from './merchant-info-settlement.component';

interface Props {
  businessData: BusinessOnboardingInformation;
}

function MerchantInfoBusinessInfo(props: Props) {
  const { businessData } = props;

  const settlements = businessData.banks.map((bank, index) => {
    return (
      <Accordion.Item key={index} label={'Settlement ' + (index + 1)} opened>
        <MerchantInfoSettlement index={index} businessData={businessData} />
      </Accordion.Item>
    );
  });

  return (
    <>
      <XInfoTabTitle
        label='Authorized Representative'
        dataCy='generalInformationTitle'
      />
      <Space h='xl' />
      <Grid data-cy='authorized'>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label='First name'
            value={businessData.representatives.authorized.firstName}
            dataCy='firstName'
          />
        </Grid.Col>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label='Middle name'
            value={businessData.representatives.authorized.middleName}
            dataCy='middleName'
          />
        </Grid.Col>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label='Last name'
            value={businessData.representatives.authorized.lastName}
            dataCy='lastName'
          />
        </Grid.Col>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label='Position'
            value={businessData.representatives.authorized.position}
            dataCy='position'
          />
        </Grid.Col>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label='Email address'
            value={businessData.representatives.authorized.emailAddress}
            dataCy='emailAddress'
          />
        </Grid.Col>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label='Contact number'
            value={
              '+63 ' + businessData.representatives.authorized.contactNumber
            }
            dataCy='contactNumber'
          />
        </Grid.Col>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label='Birthdate'
            value={
              businessData.representatives.authorized.dateOfBirth
                ? formatDate(
                    businessData.representatives.authorized.dateOfBirth.toString()
                  )
                : ''
            }
            dataCy='dateOfBirth'
          />
        </Grid.Col>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label='TIN'
            value={businessData.representatives.authorized.tin}
            dataCy='dateOfBirth'
          />
        </Grid.Col>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label='SSS'
            value={businessData.representatives.authorized.sss}
            dataCy='sss'
          />
        </Grid.Col>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label={"Mother's maiden name"}
            value={businessData.representatives.authorized.mothersMaidenName}
          />
        </Grid.Col>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label='Gender'
            value={businessData.representatives.authorized.gender}
          />
        </Grid.Col>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label='AUB nationality code'
            value={businessData.representatives.authorized.aubNationalityCode}
          />
        </Grid.Col>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label='AUB device ID'
            value={businessData.representatives.authorized.aubDeviceId}
          />
        </Grid.Col>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label='AUB ID code'
            value={businessData.representatives.authorized.aubIdCode}
          />
        </Grid.Col>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label='AUB ID number'
            value={businessData.representatives.authorized.aubIdNumber}
          />
        </Grid.Col>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label='AUB region code'
            value={businessData.representatives.authorized.aubRegionCode}
          />
        </Grid.Col>
      </Grid>

      <Divider my='xl' />

      {businessData.representatives.escalation &&
        Object.keys(businessData.representatives.escalation).length > 0 && (
          <>
            <Text size='xl' weight={700}>
              Escalation Representative
            </Text>
            <Space h='xl' />
            <Grid data-cy='escalation'>
              <Grid.Col md={3} sm={6}>
                <TextInfo
                  label='First name'
                  value={businessData.representatives.escalation?.firstName}
                  dataCy='firstName'
                />
              </Grid.Col>
              <Grid.Col md={3} sm={6}>
                <TextInfo
                  label='Middle name'
                  value={businessData.representatives.escalation?.middleName}
                  dataCy='middleName'
                />
              </Grid.Col>
              <Grid.Col md={3} sm={6}>
                <TextInfo
                  label='Last name'
                  value={businessData.representatives.escalation?.lastName}
                  dataCy='lastName'
                />
              </Grid.Col>
              <Grid.Col md={3} sm={6}>
                <TextInfo
                  label='Position'
                  value={businessData.representatives.escalation?.position}
                  dataCy='position'
                />
              </Grid.Col>
              <Grid.Col md={3} sm={6}>
                <TextInfo
                  label='Email address'
                  value={businessData.representatives.escalation?.emailAddress}
                  dataCy='emailAddress'
                />
              </Grid.Col>
              <Grid.Col md={3} sm={6}>
                <TextInfo
                  label='Contact number'
                  value={
                    '+63 ' +
                    businessData.representatives.escalation?.contactNumber
                  }
                  dataCy='contactNumber'
                />
              </Grid.Col>
              <Grid.Col md={3} sm={6}>
                <TextInfo
                  label='Birthdate'
                  value={
                    businessData.representatives.escalation.dateOfBirth
                      ? formatDate(
                          businessData.representatives.escalation.dateOfBirth.toString()
                        )
                      : ''
                  }
                  dataCy='dateOfBirth'
                />
              </Grid.Col>
              <Grid.Col md={3} sm={6}>
                <TextInfo
                  label='TIN'
                  value={businessData.representatives.escalation?.tin}
                  dataCy='tin'
                />
              </Grid.Col>
              <Grid.Col md={3} sm={6}>
                <TextInfo
                  label='SSS'
                  value={businessData.representatives.escalation?.sss}
                  dataCy='sss'
                />
              </Grid.Col>
            </Grid>

            <Divider my='xl' />
          </>
        )}

      <Text size='xl' weight={700}>
        Settlement Information
      </Text>
      <Space h='xl' />
      <Grid>
        <Grid.Col>
          <Accordion multiple initialItem={0} data-cy='settlementsAccordion'>
            {settlements}
          </Accordion>
        </Grid.Col>
        <Grid.Col md={3}>
          <TextInfo
            label='Want Packworks Wallet'
            value={businessData.isWantPackworksWallet ? 'Yes' : 'No'}
            dataCy='isWantPackworksWallet'
          />
        </Grid.Col>
        <Grid.Col md={3}>
          <TextInfo
            label='Want PayMaya Bank Account'
            value={businessData.isWantPayMayaBankAccount ? 'Yes' : 'No'}
            dataCy='isWantPayMayaBankAccount'
          />
        </Grid.Col>
        <Grid.Col md={3}>
          <TextInfo
            label='Want PayMaya Wallet'
            value={businessData.isWantPayMayaWallet ? 'Yes' : 'No'}
            dataCy='isWantPayMayaWallet'
          />
        </Grid.Col>
      </Grid>
    </>
  );
}

export default MerchantInfoBusinessInfo;
